module.exports = __webpack_public_path__ + "img/store-google.eee5195.svg";